/**
 *
 * @module bamIdentityClientConfiguration
 *
 */

import ServiceClientConfiguration from './../../configuration/serviceClientConfiguration';

/**
 *
 * @class BamIdentityClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the BamIdentityClient.
 *
 */
export default class BamIdentityClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/identity/bam/bamIdentityClientConfiguration.js